import {
    CloudUploadOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Button, Card, Descriptions, Divider, Form, Input, notification, Popconfirm, Popover, Row, Space, Timeline, Typography, Upload } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { useRouter } from '../../../../routes'
import { FileLink, JobStatus } from '../../components'
import DashboardLayout, { DashboardPage } from '../../layout'
import JobActions from './job_actions'
import JobTasksTableView from './job_tasks'
import TasksStats from './tasks_stats'

import AddComment from './add_comment'

const useStyles = makeStyles(theme => ({
    cardLineItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    cardStyle: {
        borderRadius: '6px',
        boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)',
        marginBottom: '20px',
    },
    flexHorizontal: {
        flexDirection: 'row',
    },
    root: {
        height: '100%',
        width: '100%'
    },
    top: {
        width: '100%',
        marginBottom: theme.spacing(4)
    },
    title: {
        marginBottom: 4,
        color: 'rgba(0, 0, 0, 0.45)',
        fontSize: 14
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    actions: {
        marginBottom: theme.spacing(3)
    },
    progress: {
        marginBottom: theme.spacing(3)
    }
}))

/**
 * This page contains the details of a selected job
 *
 * It shows status information of a scheduled job and provides the user with actions to run the job, check the status or run subsequent schedules
 * It also provides the user with important input and output files for download
 */

const JobDetailsPage = (props) => {
    const [job, setJob] = useState(null)
    const [tool, setTool] = useState(null)

    const router = useRouter()
    const classes = useStyles()
    const data = useData()
    const jobs = data.jobs()
    const tools = data.tools()

    const { query } = router
    const jobId = query && query.id
    const [new_concurrency, SetNewConcurrency] = useState('')
    const [editconcurrency, SetShowEditConcurrency] = useState(false)

    const [currentPage, SetCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [count, setCount] = useState(0)
    const [filter, setFilter] = useState([])
    const [ordering, setOrdering] = useState(router.query?.ordering ?? '-id')



    if (!jobId) {
        router.back()
    }

    // load the job
    const loadJob = (full = false) => {

        if (jobId && full == false) {
            trackPromise(
                jobs.jobDetails(jobId, currentPage, limit, filter)
                    .then((job) => {
                        setJob(job)
                        SetNewConcurrency(job.concurrency_factor)
                        setCount(job.job_tasks_pages_count)
                    })
                    .catch(console.log),
            )
        }
        if (jobId && full) {
            trackPromise(
                jobs.loadall(jobId)
                    .then((job) => {
                        setJob(job)
                        SetNewConcurrency(job.concurrency_factor)
                    })
                    .catch(console.log)
            )
        }
    }

    // get details
    useEffect(() => {
        loadJob()
    }, [limit, currentPage, filter])

    // refresh this job details
    const refreshJob = () => {
        if (jobId) {
            trackPromise(
                jobs.jobDetails(jobId, currentPage, limit, filter)
                    .then((job) => {
                        setJob(job)
                        SetNewConcurrency(job.concurrency_factor)
                        setCount(job.job_tasks_pages_count)
                    })
                    .catch(console.log), 'refresh'
            )
        }
    }

    // useEffect(() => {
    //     // load details every 10 seconds 
    //     let interval;
    //     if (job?.status === "PROCESSING") {
    //         interval = setInterval(() => refreshJob(), 10 * 1000)
    //     }

    //     return () => clearInterval(interval)
    // }, [job])

    // get the tool running this job
    // useEffect(() => {
    //     if (job) {
    //         const { tool } = job
    //         if (tool) {
    //             tools.getToolDetails(tool)
    //                 .then(setTool)
    //                 .catch(console.log)
    //         }
    //     }
    // }, [job])

    // reload after running details
    // const reload = () => loadJob()

    // useEffect(() => {
    //     if (tool) {
    //         const { category } = tool
    //         const { is_cookies_required } = tool
    //         const canShow = category === 'contact' || is_cookies_required
    //     }
    // }, [tool])

    const editable = () => {
        // check if this job input can be edited,
        // only jobs in processing stage are undetitable 
        return job?.status !== "PROCESSING"
    }
    const showConcurrency = () => {
        SetShowEditConcurrency(!editconcurrency)
    }
    const deleteaoutput = (job) => {
        trackPromise(
            jobs.deletejoboutput(job.id).then(() => {
                // reload this job
                loadJob()
                notification.success({
                    description: "Job output deleted succesfully."
                })

            }).catch(err => {
                notification.error({
                    description: "An error occured updating the Job output deletion."
                })

            }),
        )

    }
    const changeConcurrency = () => {
        if (job) {
            const { id } = job
            trackPromise(
                jobs.updateJob(id, new_concurrency)
                    .then(() => {
                        // reload this job
                        loadJob()
                        notification.success({
                            description: "Concurrency factor updated succesfully."
                        })
                        SetShowEditConcurrency(!editconcurrency)
                    }).catch(err => {
                        notification.error({
                            description: "An error occured updating the Concurrency factor."
                        })
                        console.error(err)
                    }), 'Concurrency _actor'
            )
        }
    }
    const changeInputFile = ({ fileList }) => {
        if (fileList.length) {
            const file = fileList[0]

            if (job) {
                const { id } = job

                // update the job input file 
                trackPromise(
                    jobs.updateInputFile(id, file)
                        .then(() => {
                            // reload this job
                            loadJob()
                            notification.success({
                                description: "Input file updated succesfully."
                            })
                        }).catch(err => {
                            notification.error({
                                description: "An error occured updating the input file."
                            })
                            console.error(err)
                        }), 'update_input_file'
                )
            }
        }
    }

    const updating = usePromiseTracker({ area: 'update_input_file' }).promiseInProgress


    return (
        <DashboardLayout selected="jobs">
            <DashboardPage
                title="Job Details"
                hasCta={false}
            >
                {
                    job && (
                        <div className={classes.root}>

                            <Row justify="end" style={{ marginBottom: '15px' }}>
                                <JobActions job_id={jobId} job={job} setJob={setJob} loadJob={refreshJob} />
                                {/* <AddCookies job={job} refresh={refreshJob} /> */}
                            </Row>

                            <TasksStats task_stats={job.job_tasks_stats} />

                            <Card className={classes.cardStyle}>
                                <Descriptions title="Job details" bordered size='small'>

                                    <Descriptions.Item label="Job Name:" span={2}>
                                        <span style={{ overflowWrap: 'anywhere' }}>{job.name}</span>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Status:" span={2}>
                                        <JobStatus status={job.status} />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Run Time:" span={2}>
                                        <Typography.Text strong>
                                            <span style={{ overflowWrap: 'anywhere' }}>{moment.utc(moment.duration(job.total_time, 's').asMilliseconds()).format("HH:mm:ss")}</span>
                                        </Typography.Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Tool:" span={2}>
                                        <Typography.Text strong>
                                            <span
                                                style={{ cursor: 'pointer', overflowWrap: 'anywhere' }}
                                                onClick={() => router.push(`/dashboard/tool?id=${job.tool}`)}
                                            >
                                                {job.tool_display}
                                            </span>
                                        </Typography.Text>
                                    </Descriptions.Item>


                                    <Descriptions.Item label="Job ID" span={2}>{job.id}</Descriptions.Item>

                                    <Descriptions.Item label="Creator" span={2}>{job.created_by_name}</Descriptions.Item>
                                    <Descriptions.Item label="Job description" span={3}>{job.description} </Descriptions.Item>

                                    <Descriptions.Item label="Created at" span={2}>{moment(job.created_at).format("YYYY-MM-DD HH:mm")}</Descriptions.Item>
                                    <Descriptions.Item label="Updated at" span={2}>{moment(job.updated_at).format("YYYY-MM-DD HH:mm")}</Descriptions.Item>

                                    <Descriptions.Item label="Parameters" span={3}> <pre>{JSON.stringify(job.params)}</pre> </Descriptions.Item>
                                    <Descriptions.Item label="Concurrency" span={0}>

                                        <pre>{job.concurrency_factor}
                                            <EditOutlined onClick={showConcurrency} />

                                        </pre>
                                    </Descriptions.Item>
                                    <Descriptions.Item span={2}>
                                        <div>
                                            <div >
                                                <span >
                                                    {editconcurrency &&
                                                        <Form
                                                            name="customized_form_controls"
                                                            layout="inline"
                                                            onFinish={changeConcurrency}
                                                        >
                                                            <Form.Item

                                                                rules={[{ required: true, message: 'Type is required' }]} onChange={(event) => SetNewConcurrency(event.target.value)}
                                                            >
                                                                <Input class="ant-input-number-input" size="small" onChange={(event) => SetNewConcurrency(event.target.value)} value={new_concurrency} type="number" min="1" />

                                                            </Form.Item>
                                                            <Form.Item>
                                                                <Button type="primary" htmlType="submit">
                                                                    Update
                                                                </Button>
                                                            </Form.Item>
                                                        </Form>
                                                    }

                                                </span>

                                            </div >
                                        </div>

                                    </Descriptions.Item>
                                    <Descriptions.Item label="Job Metrics" span={3}>
                                        {
                                            job.metrics.map(m => <div key={m.id}>{m.metric_key} - {m.metric_value}</div>)
                                        }
                                    </Descriptions.Item>
                                    {(job.type == 'scrapy') && (
                                        <Descriptions.Item label="Task Id" span={3}>
                                            {job.scrapyd_task_id}
                                        </Descriptions.Item>
                                    )}
                                    {(job.type == 'scrapy') && (
                                        <Descriptions.Item label="Log file " span={3}>
                                            <Space>
                                                <FileLink file_url={job.logs} show_file_label={true} />
                                            </Space>
                                        </Descriptions.Item>
                                    )}


                                    <Descriptions.Item label="Input file" span={3}>
                                        <Space>
                                            <FileLink file_url={job.input_file} show_file_label={true} />
                                            {editable() && (
                                                <Popover placement="top" content={<>Change the input file</>} trigger="hover">
                                                    <Upload
                                                        name="input_file"
                                                        accept=".csv"
                                                        beforeUpload={() => {
                                                            return false
                                                        }}
                                                        multiple={false}
                                                        maxCount={1}
                                                        onChange={changeInputFile}
                                                        showUploadList={false}
                                                    >
                                                        <Button icon={<CloudUploadOutlined />} />
                                                    </Upload>
                                                </Popover>
                                            )}
                                        </Space>
                                    </Descriptions.Item>

                                    <Descriptions.Item label="Output Files" span={3}>
                                        {
                                            job.outputs.map(link => (
                                                <Card size="small">
                                                    <Space>
                                                        <FileLink file_url={link.output_file} show_file_label={true} />
                                                        <Popconfirm
                                                            title="Are you sure to delete this job?"
                                                            onConfirm={() => deleteaoutput(link)}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <Button danger size='small' icon={<DeleteOutlined />} />
                                                        </Popconfirm>

                                                    </Space>
                                                </Card>
                                            ))
                                        }
                                    </Descriptions.Item>

                                    {job.error?.message &&
                                        <Descriptions.Item label="Error Messages" span={3}>
                                            <ul>
                                                {job.error.message.map(m => <li><p>{m}</p></li>)}
                                            </ul>
                                        </Descriptions.Item>
                                    }

                                </Descriptions>
                            </Card>
                            <Button type="link" onClick={() => loadJob(true)} size="small">All Records</Button>
                            {
                                <JobTasksTableView
                                    job_tasks={job.job_tasks}
                                    job_type={job.type}
                                    refresh={refreshJob}
                                    job_id={job.id}
                                    count={count}
                                    updateLimit={setLimit}
                                    updatePage={SetCurrentPage}
                                    page={currentPage}
                                    limit={limit}
                                    setOrdering={setOrdering}
                                    filter={filter}
                                    setFilter={setFilter}
                                />
                            }

                            <Divider />
                            <Card title="Job Notes">
                                <AddComment job={job} refresh={refreshJob} />
                            </Card>
                            <Card title="Job History">
                                <Timeline mode={'left'} style={{ marginTop: '48px' }}>
                                    {job.history?.map((history) => (
                                        <Timeline.Item label={moment(history.created_at).format("YYYY-MM-DD HH:mm")}>
                                            <Typography.Text strong>{history.status} </Typography.Text>
                                            by <Typography.Text>{history.user}</Typography.Text>
                                        </Timeline.Item>
                                    ))}
                                </Timeline>
                            </Card>
                        </div>
                    )
                }
            </DashboardPage>
        </DashboardLayout>
    )
}

export default JobDetailsPage
